/**
 * Запуск веб-оболочки (тикет T18b).
 *
 * Строгий режим включён нарочно: он вызывает работу с сервером дважды и тем самым ловит
 * подписки, которые забыли снять. Такая ошибка на глаз не видна — она проявляется через
 * час работы в виде двух одинаковых Сообщений или Раскладки, вернувшейся к вчерашней.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Корень страницы не найден — проверьте index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
